import { render, staticRenderFns } from "./SectionAchievements.vue?vue&type=template&id=47da303b&scoped=true&"
import script from "./SectionAchievements.vue?vue&type=script&lang=ts&"
export * from "./SectionAchievements.vue?vue&type=script&lang=ts&"
import style0 from "./SectionAchievements.vue?vue&type=style&index=0&id=47da303b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47da303b",
  null
  
)

export default component.exports